import { createConfig } from 'wagmi';
import { formatEther, http } from 'viem';
import { sonic } from 'wagmi/chains';
import { getBalance, readContract } from '@wagmi/core';
import { erc20Abi } from 'viem';

const OPERATOR_ADDRESS = '0xb305630FA4a70525A3C201C786111D33A27dd60e';
const MASTERCHEF_ADDRESS = '0x1a5Ded6adCfc64aceDE86151B1F142088C6E03da';
const METRO_TOKEN_ADDRESS = '0x71E99522EaD5E21CF57F1f542Dc4ad2E841F7321';

// @ts-ignore: Ignoriere den TS-Fehler hier
export const config = createConfig({
  chains: [sonic],
  transports: {
    [sonic.id]: http()
  }
});
// @ts-ignore: Ignoriere den TS-Fehler hier

export async function fetchOperatorBalance(): Promise<string> {
    try {
        const balance = await getBalance(config, {
            address: OPERATOR_ADDRESS as `0x${string}`,
        });
        return balance.formatted;
    } catch (error) {
        console.error('Error fetching operator balance:', error);
        return "N/A"; // Fallback für den Demo-Modus
    }
}
// @ts-ignore: Ignoriere den TS-Fehler hier
export async function fetchMasterChefMetroBalance(): Promise<string> {
    try {// @ts-ignore: Ignoriere den TS-Fehler hier
        const balance = await readContract(config, {
            address: METRO_TOKEN_ADDRESS as `0x${string}`,
            abi: erc20Abi,
            functionName: 'balanceOf',
            args: [MASTERCHEF_ADDRESS as `0x${string}`],
        });
        return formatEther(balance);
    } catch (error) {
        console.error('Error fetching MasterChef METRO balance:', error);
        return "N/A"; // Fallback für den Demo-Modus
    }
} 